import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationMenuComponent } from './navigation-menu.component';

@NgModule({
  imports: [CommonModule],
  exports: [NavigationMenuComponent],
  declarations: [NavigationMenuComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NavigationMenuModule {}
